import request from "@/utils/request.js";
export function fetchList(params) {
    return request({
        url: '/v2/inspect/record/room',
        method: 'GET',
        params
    })
}
export function addOne(data) {
    return request({
        url: '/v2/inspect/record/room',
        method: 'POST',
        data
    })
}

export function fetchOne(id) {
    return request({
        url: `/v2/inspect/record/room/${id}`,
        method: 'get'
    })
}